import React from "react";
import { makeObservable, observable, action } from "mobx";
import { observer } from "mobx-react";

type LanguageSelectorProps = {
  languageCode: string;
  onLanguageChange?: (languageCode: string) => void;
};

@observer
export default class LanguageSelector extends React.Component<LanguageSelectorProps> {
  @observable _languages = [
    { value: 'en', name: 'English', nativeName: 'English' },
    { value: 'pl', name: 'Polish', nativeName: 'Polski' },
    { value: 'ru', name: 'Russian', nativeName: 'Русский' },
    { value: 'de', name: 'German', nativeName: 'Deutsch' }
  ];

  @observable _isOpen = false;
  private _dropdownRef = React.createRef<HTMLDivElement>();

  constructor(props: LanguageSelectorProps) {
    super(props);
    makeObservable(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this._handleClickOutside);
    document.addEventListener('touchstart', this._handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this._handleClickOutside);
    document.removeEventListener('touchstart', this._handleClickOutside);
  }

  @action
  private _handleClickOutside = (event: MouseEvent | TouchEvent) => {
    if (this._dropdownRef.current && !this._dropdownRef.current.contains(event.target as Node)) {
      this._isOpen = false;
    }
  };

  @action
  private _toggleDropdown = () => {
    this._isOpen = !this._isOpen;
  };

  @action
  private _onLanguageChange(value: string): void {
    this._isOpen = false; // Close dropdown when option is selected
    this.props.onLanguageChange?.(value);
  }

  render() {
    return (
      <div className="language-select" ref={this._dropdownRef}>
        <div 
          className={`dropdown-selected ${this._isOpen ? 'open' : ''}`} 
          onClick={this._toggleDropdown}
        >
          {this._languages.find(lang => lang.value === this.props.languageCode)?.name}
        </div>
        {this._isOpen && (
          <div className={`dropdown-options ${this._isOpen ? 'open' : ''}`}>
            {this._languages.map(lang => (
              <div
                key={lang.value}
                className={`dropdown-option ${lang.value === this.props.languageCode ? 'selected' : ''}`}
                data-value={lang.value}
                onClick={() => this._onLanguageChange(lang.value)}
              >
                {lang.name} ({lang.nativeName})
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}